// Form field keys used in manual document payload building
export const FORM_FIELD_KEYS = {
  UPLOADED_DOCUMENT: "uploadedDocument",
  PDF_FILE: "pdfFile",
  RECURRING_DOCUMENT: "RecurringDocument",
  SPAIN_CORRECTION_CODE: "spainCorrectionCode",
} as const;

// Recurring document date fields
export const RECURRING_DATE_FIELDS = {
  START_DATE: "startDate",
  END_DATE: "endDate",
} as const;
